export const hideWorkingAreas = ['/working_area', '/super_admin'];

export const hideDataEntry = [
  '/data_entry',
  '/super_admin',
  '/working_area',
  '/dashboard',
  '/data_management',
  '/data_management/ict_systems',
  '/data_management/data',
  '/reporting',
  '/additional_reporting',
  '/article8',
  '/article8/risk_exposure',
  '/article8/dependency_type',
  '/article8/exposure_category',
  '/article8/ict_system_criticality',
  '/article8/entity_role',
  '/article8/role_type',
  '/article8/ict_risk',
  '/article8/risk_source',
  '/article8/risk_level',
  '/article8/responsibility',
  '/article_8_reporting',
  '/article8/risk_exposure_layout',
  '/article8/master_data',
];

export const hideDataManagement = [
  '/data_entry',
  '/super_admin',
  '/working_area',
  '/data_management',
  '/data_entry/entity_maintaining_registry',
  '/data_entry/entity',
  '/data_entry/branch',
  '/data_entry/function',
  '/data_entry/third_party_provider',
  '/data_entry/contractual_information',
  '/data_entry/ict_service',
  '/reporting',
  '/additional_reporting',
  '/article8/risk_exposure',
  '/article8/dependency_type',
  '/article8/exposure_category',
  '/article8/ict_system_criticality',
  '/article8/entity_role',
  '/article8/role_type',
  '/article8/ict_risk',
  '/article8/risk_source',
  '/article8/risk_level',
  '/article8/responsibility',
  '/article8',
  '/article_8_reporting',
  '/article8/risk_exposure_layout',
  '/article8/master_data',
];

export const hideArticle8 = [
  '/data_entry',
  '/super_admin',
  '/working_area',
  '/data_management',
  '/data_entry/entity_maintaining_registry',
  '/data_entry/entity',
  '/data_entry/branch',
  '/data_entry/function',
  '/data_entry/third_party_provider',
  '/data_entry/contractual_information',
  '/data_entry/ict_service',
  '/reporting',
  '/additional_reporting',
  '/data_management/report99',
  '/data_management/ict_systems',
  '/data_management/data',
  '/article8',
];
